import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c53e75fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "help-text"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "assertion-field"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Subject type", -1))
const _hoisted_10 = { class: "subject-type" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "input-value"
}
const _hoisted_13 = {
  key: 1,
  class: "assertion-field"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Spouse", -1))
const _hoisted_15 = { class: "spouse-subject" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "input-value"
}
const _hoisted_19 = { class: "assertion-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Type", -1))
const _hoisted_21 = { class: "assertion-type" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 2,
  class: "input-value"
}
const _hoisted_25 = {
  key: 2,
  class: "assertion-field"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date", -1))
const _hoisted_27 = ["readonly"]
const _hoisted_28 = { class: "assertion-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Given", -1))
const _hoisted_30 = ["readonly"]
const _hoisted_31 = { class: "assertion-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Surname", -1))
const _hoisted_33 = ["readonly"]
const _hoisted_34 = {
  key: 4,
  class: "assertion-field"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Value", -1))
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Unknown", -1))
const _hoisted_38 = ["readonly"]
const _hoisted_39 = {
  key: 5,
  class: "owner-profile"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Defined in another profile ", -1))
const _hoisted_41 = { class: "modal-footer" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled", "onClick"]
const _hoisted_44 = ["disabled"]

import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useAssertionStore } from '@/rd/AssertionStore'
import { useAssertionTypeDefinitionStore } from '@/rd/AssertionTypeDefinitionStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useFamilyStore } from '@/rd/FamilyStore'
import { usePlaceStore } from '@/rd/PlaceStore'
import { Assertion, AssertionType, Gender, ItemType, PersonName, ViewFamily, ViewPerson } from '@/rd/ResearchDataModel'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { AssertionTypeIcons } from '@/explore/AssertionTypeIcons'
import { CompositeId } from '@/rd/CompositeId'
import { Modal as BsModal } from 'bootstrap'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { PatchChange } from '@/util/Api'
import { LoadMode } from '@/util/AsyncData'
import { assignExisting } from '@/util/TypeScriptUtil'
import { HistoricalDate } from '@/rd/HistoricalDate'
import { HistoricalDateFormat } from '@/rd/HistoricalDateEnums'
import { SortDate } from '@/rd/SortDate'
import { AsyncUtil } from '@/util/AsyncUtil'
import { Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { useModalAutoHide } from '@/util/AppUtil'
import Spinner from '@/util/Spinner.vue'
import ProfileCard from './ProfileCard.vue'
import Modal from '@/util/Modal.vue'

interface SpouseFamilySubject {
  familyId: string
  viewFamily: ViewFamily
  spouseId?: string
  spouse?: ViewPerson
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssertionModal',
  props: {
    contextPersonId: {}
  },
  emits: ["delete"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  open,
  reset: () => busyRef.value = false,
  close,
})

const subjectTypes = [
  ItemType.Person,
  ItemType.Family,
]

const valueListRef = [
  { value: Gender.Male, name: Gender.Male },
  { value: Gender.Female, name: Gender.Female },
]

const busyRef = ref(false)
const ownerPersonIdRef = ref<string>()
const assertionRef = ref<Readonly<Assertion>>()
const editSubjectTypeRef = ref(ItemType.Person)
const editSubjectIdRef = ref('')
const editTypeRef = ref<string>()
const editDateRef = ref<string>()
const editValueRef = ref<string>()
const editNameValue = reactive(new PersonName())
const modalRef = ref<HTMLElement>()

const assertionStore = useAssertionStore()
const dataGroupStore = useDataGroupStore()
const familyStore = useFamilyStore()
const definitionStore = useAssertionTypeDefinitionStore()
const personStore = usePersonStore()
const viewPersonStore = useViewPersonStore()
const placeStore = usePlaceStore()

useModalAutoHide(modalRef)

const contextPersonRef = computed(() => personStore.getLoadedPersonList([props.contextPersonId]).at(0))
const contextViewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.contextPersonId))
const spouseFamilySubjectsRef = computed(() => {
  if (!props.contextPersonId || !contextViewPersonRef.value)
    return []

  // get spouse families with a matching family in the current person's group
  const contextGroupIdRef = CompositeId.getGroupId(props.contextPersonId)!
  const spFams = viewPersonStore.getLoadedSpouseFamilies(props.contextPersonId)
  const spFamSubjects = [] as SpouseFamilySubject[]
  for (const vf of spFams.spouseFamilies) {
    var personFamId = isNewRef.value
      ? vf.matchIds.find(id => CompositeId.hasGroupId(id, contextGroupIdRef)) // only include context-owned families
      : vf.id
    var spouseId = vf.spouseOf(contextViewPersonRef.value.id!)
    if (personFamId) {
      spFamSubjects.push({
        familyId: personFamId,
        viewFamily: vf,
        spouseId,
        spouse: viewPersonStore.getLoadedPerson(spouseId)
      })
    }
  }
  return spFamSubjects
})
const subjectPersonRef = computed(() => {
  if (editSubjectTypeRef.value == ItemType.Person)
    return contextPersonRef.value

  const sf = spouseFamilySubjectsRef.value.find(sf => sf.viewFamily.matchIds.includes(editSubjectIdRef.value))
  return sf?.spouse
})
const dataGroupIdRef = computed(() => CompositeId.getGroupId(assertionRef.value?.subjectId))
const isNewRef = computed(() => !assertionRef.value?.id)
const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(dataGroupIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canModifyRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) != 0)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(dataGroupIdRef.value, LoadMode.EnsureLoaded)?.data)
const isTrackingRef = computed(() => !!dataGroupRef.value?.trackedGroupId)
const canEditRef = computed(() => (isNewRef.value || assertionRef.value?.profile) && canModifyRef.value && !isTrackingRef.value && isContextOwnedRef.value)
const isContextOwnedRef = computed(() => ownerPersonIdRef.value == props.contextPersonId)

const assertionTypeIcon = computed(() => AssertionTypeIcons.getIcon(editTypeRef.value))
const definitionRef = computed(() => definitionStore.getAsyncDefinition(editTypeRef.value, LoadMode.EnsureLoaded)?.data)

const isNameRef = computed(() => editTypeRef.value == AssertionType.Name)
const nameValueRef = computed(() => isNameRef.value ? new PersonName(assertionRef.value?.value) : undefined)
const editDateValueRef = computed(() => HistoricalDate.parseUserInput(editDateRef.value))

const sortedDefinitions = computed(() => definitionStore.getDefinitionsForCommon(LoadMode.EnsureLoaded)
  .filter(d => assertionRef.value && d.subjectTypes.includes(editSubjectTypeRef.value))
  .sort((a, b) => a.type!.localeCompare(b.type!)))

const useValueListRef = computed(() => editTypeRef.value == AssertionType.Gender)

const hasChangesRef = computed(() => {
  return assertionRef.value && (
    isNewRef.value ||
    editSubjectTypeRef.value != assertionRef.value.subjectType ||
    editSubjectIdRef.value != assertionRef.value.subjectId ||
    editTypeRef.value != assertionRef.value.assertionType ||
    (definitionRef.value?.useDate && !editDateValueRef.value.equals(assertionRef.value.date)) ||
    (definitionRef.value?.useValue && editValueRef.value != assertionRef.value.value)
  )
})
const canSaveRef = computed(() => !!editTypeRef.value && hasChangesRef.value)

watch(editSubjectTypeRef, () => {
  // only react when subject type is editable (new assertion)
  if (isNewRef.value) {
    if (editSubjectTypeRef.value == ItemType.Person) {
      editSubjectIdRef.value = ownerPersonIdRef.value!
    }
    else if (spouseFamilySubjectsRef.value.length > 0) {
      editSubjectIdRef.value = spouseFamilySubjectsRef.value[0].familyId
    }
  }
})

watch(editNameValue, () => {
  editValueRef.value = editNameValue.getValue()
})

function open(assertionId?: string) {
  if (assertionId) {
    assertionRef.value = assertionStore.getAsyncAssertion(assertionId)!.data! // loaded by parent

    if (assertionRef.value.subjectType == ItemType.Person) {
      // owner is the assertion subject
      ownerPersonIdRef.value = assertionRef.value.subjectId
    }
    else if (assertionRef.value.profile) {
      // NOTE: in a profile, only spouse families can have assertions (not parent or other placeholder families)
      const dataGroup = dataGroupStore.getLoadedGroup(CompositeId.getGroupId(assertionId)) // loaded by parent
      ownerPersonIdRef.value = dataGroup?.startItemId
    }
    else {
      // NOTE: in a research group, the "owner" profile for a family is the father if present, otherwise the mother
      const family = familyStore.getLoadedFamily(assertionRef.value.subjectId!)! // loaded by parent
      ownerPersonIdRef.value = family.fatherId ?? family.motherId
    }
  }
  else {
    const newAssertion = new Assertion()
    newAssertion.subjectId = props.contextPersonId
    newAssertion.subjectType = ItemType.Person
    assertionRef.value = newAssertion

    ownerPersonIdRef.value = props.contextPersonId
  }

  if (modalRef.value && assertionRef.value) {

    editSubjectTypeRef.value = assertionRef.value.subjectType!
    editSubjectIdRef.value = assertionRef.value.subjectId!
    editTypeRef.value = assertionRef.value.assertionType
    editDateRef.value = assertionRef.value.date.toString(HistoricalDateFormat.LongDisplay)
    editValueRef.value = assertionRef.value.value
    if (isNameRef.value) {
      assignExisting(editNameValue, new PersonName(editValueRef.value))
    }

    // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
    // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
    BsModal.getOrCreateInstance(modalRef.value).show()
  }
}

function close() {
  BsModal.getInstance(modalRef.value!)!.hide()
}

async function onSave() {
  if (assertionRef.value && canSaveRef.value) {

    try {
      busyRef.value = true

      const modAssertion = new Assertion()
      assignExisting(modAssertion, assertionRef.value!)

      modAssertion.subjectType = editSubjectTypeRef.value
      modAssertion.subjectId = editSubjectIdRef.value
      modAssertion.assertionType = editTypeRef.value!

      if (definitionRef.value!.useDate) {
        const dateValue = editDateValueRef.value
        modAssertion.date = dateValue
        modAssertion.sortDate = SortDate.parse(dateValue.sortValue)
      }

      if (definitionRef.value!.useValue) {
        modAssertion.value = editValueRef.value
      }

      if (isNewRef.value) {
        const groupId = CompositeId.getGroupId(modAssertion.subjectId)!
        await AsyncUtil.atLeast(500, assertionStore.addAsync(groupId, modAssertion))
      }
      else {
        const changes: PatchChange[] = []

        // HACK: patchAsync requires protocol format, unlike addAsync
        const dateValueString = modAssertion.date.toString()
        if (dateValueString != assertionRef.value!.date.toString()) {
          changes.push(new PatchChange('/date', dateValueString))
        }
        if (modAssertion.value != assertionRef.value!.value) {
          changes.push(new PatchChange('/value', modAssertion.value))
        }

        await AsyncUtil.atLeast(500, assertionStore.patchAsync(assertionRef.value.id!, changes))
      }
    }
    finally {
      busyRef.value = false
    }

    close()
  }
}

async function onDelete() {
  emit('delete', assertionRef.value?.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalRef",
    ref: modalRef,
    class: "modal assertion-modal",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(editSubjectTypeRef.value == _unref(ItemType).Person ? "Person detail" : "Family detail"), 1),
            (isContextOwnedRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Defined in this profile "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (isNewRef.value && spouseFamilySubjectsRef.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (isNewRef.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "form-select",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editSubjectTypeRef).value = $event))
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(subjectTypes, (t) => {
                          return _createElementVNode("option", {
                            value: t,
                            key: t
                          }, _toDisplayString(t), 9, _hoisted_11)
                        }), 64))
                      ], 512)), [
                        [_vModelSelect, editSubjectTypeRef.value]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(editSubjectTypeRef.value), 1))
                ])
              ]))
            : _createCommentVNode("", true),
          (editSubjectTypeRef.value == _unref(ItemType).Family)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (isNewRef.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "form-select",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editSubjectIdRef).value = $event)),
                        disabled: spouseFamilySubjectsRef.value.length < 2
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spouseFamilySubjectsRef.value, (sp) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: sp.familyId,
                            key: sp.familyId
                          }, _toDisplayString(sp.spouse?.displayName), 9, _hoisted_17))
                        }), 128))
                      ], 8, _hoisted_16)), [
                        [_vModelSelect, editSubjectIdRef.value]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(subjectPersonRef.value?.displayName), 1))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (assertionTypeIcon.value && !isNewRef.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: assertionTypeIcon.value
                  }, null, 8, _hoisted_22))
                : _createCommentVNode("", true),
              (isNewRef.value)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editTypeRef).value = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedDefinitions.value, (d) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: d.type,
                        key: d.type
                      }, _toDisplayString(d.type), 9, _hoisted_23))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, editTypeRef.value]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(assertionRef.value?.assertionType), 1))
            ])
          ]),
          (definitionRef.value?.useDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                (canEditRef.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      class: "form-control",
                      placeholder: "e.g., 1 Jan 2000",
                      readonly: busyRef.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editDateRef).value = $event))
                    }, null, 8, _hoisted_27)), [
                      [_vModelText, editDateRef.value]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", { class: "input-value" }, _toDisplayString(assertionRef.value?.date.toString(_unref(HistoricalDateFormat).LongDisplay)), 513), [
                  [_vShow, !canEditRef.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (isNameRef.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  (canEditRef.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control",
                        readonly: busyRef.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editNameValue.given) = $event))
                      }, null, 8, _hoisted_30)), [
                        [_vModelText, editNameValue.given]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", { class: "input-value" }, _toDisplayString(nameValueRef.value?.given), 513), [
                    [_vShow, !canEditRef.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  (canEditRef.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control",
                        readonly: busyRef.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editNameValue.surname) = $event))
                      }, null, 8, _hoisted_33)), [
                        [_vModelText, editNameValue.surname]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", { class: "input-value" }, _toDisplayString(nameValueRef.value?.surname), 513), [
                    [_vShow, !canEditRef.value]
                  ])
                ])
              ], 64))
            : (definitionRef.value?.useValue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  (canEditRef.value && useValueListRef.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "form-select",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editValueRef).value = $event))
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(valueListRef, (v) => {
                          return _createElementVNode("option", {
                            value: v.value,
                            key: v.value
                          }, _toDisplayString(v.name), 9, _hoisted_36)
                        }), 64)),
                        _hoisted_37
                      ], 512)), [
                        [_vModelSelect, editValueRef.value]
                      ])
                    : (canEditRef.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control",
                          readonly: busyRef.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editValueRef).value = $event))
                        }, null, 8, _hoisted_38)), [
                          [_vModelText, editValueRef.value]
                        ])
                      : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", { class: "input-value" }, _toDisplayString(assertionRef.value?.value), 513), [
                    [_vShow, !canEditRef.value]
                  ])
                ]))
              : _createCommentVNode("", true),
          (!isContextOwnedRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(ProfileCard, {
                  "person-id": ownerPersonIdRef.value,
                  "show-profile-type": ""
                }, null, 8, ["person-id"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          (canEditRef.value && !isNewRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-primary delete-action",
                disabled: busyRef.value,
                onClick: onDelete
              }, " Delete ", 8, _hoisted_42))
            : _createCommentVNode("", true),
          (!canEditRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                onClick: close
              }, " Close "))
            : _createCommentVNode("", true),
          (canEditRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "submit",
                class: "btn btn-primary",
                disabled: !canSaveRef.value || busyRef.value,
                onClick: _withModifiers(onSave, ["prevent"])
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                  : _createCommentVNode("", true),
                _createTextVNode(" Save ")
              ], 8, _hoisted_43))
            : _createCommentVNode("", true),
          (canEditRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "btn btn-outline-primary",
                disabled: busyRef.value,
                onClick: close
              }, " Cancel ", 8, _hoisted_44))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}
}

})